<template>
    <!-- this template is currently for delete products only -->
    <div class="modal__input-area">
         <div class="modal__input-container">
            <input id="id-password" v-model="password" class="modal__input" placeholder=" " type="password"> 
                
            <label class="modal__label" for="id-password">password</label>
        </div>
        
            <div class="modal__buttons-container">
                <button @click="deleteItem" class="modal__button modal__button--delete" >
                    <div v-if="loading"><filling-circle :size="16" /></div>
                    <div style="padding-left:1em;">Delete</div>
                </button>
            </div>
    </div>
</template>

<script>
import FillingCircle from '@/components/Loaders/FillingCircle.vue'

export default {
    data(){
        return {
            loading: false,
            password: "",
        }
    },
    components:{
        FillingCircle
    },
    computed:{
        id(){
            return this.$route.params.id
        },
        subId(){
            return this.$route.params.subId
        }
    },
    methods:{
        deleteItem(){
            console.log(this.id)
            this.loading = true
            this.$store.dispatch({
                type:'products/deleteCategoryInstance',
                subId: this.subId,
                id: this.id,
                password: this.password
            }).then(()=>{
                this.loading=false
                
                this.$router.go(-1)
            }).catch(error=>{
                console.log(error.response.data)
                this.loading = false
            })
        },
    },
    

}
</script>